<template>
    <div>
        <h1>
            <el-page-header @back="goBack" :content="secondBlock.name.concat('选品')">
            </el-page-header>
        </h1>
        <el-card class="form-container" shadow="never">
            <el-button type="primary" @click="showDetails('添加应用')">添加应用</el-button>
        </el-card>
        <el-card class="form-container" shadow="never">
            <el-table border
                      :data="selectList"
                      height="690"
                      style="width: 100%">
                <el-table-column label="序号" prop="id" align="center"></el-table-column>
                <el-table-column label="应用名称" prop="appLink.name" align="center"></el-table-column>
                <el-table-column label="详细" prop="appLink.detail" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column label="跳转链接" prop="appLink.widgetScheme" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column  label="应用图片"  align="center">
                    <template slot-scope="scope">
                        <template>
                            <img :src="VUE_APP_CDN_URL+scope.row.appLink.image" width="60px" height="60px" />
                        </template>
                    </template>
                </el-table-column>
                <el-table-column  label="线性图标"  align="center">
                    <template slot-scope="scope">
                        <template>
                            <img :src="VUE_APP_CDN_URL+scope.row.appLink.imageLine" width="60px" height="60px" />
                        </template>
                    </template>
                </el-table-column>
                <el-table-column  label="排序"  align="center">
                    <template slot-scope="scope" >
                        <el-input-number size="small" :min="0" style="width: 110px" v-model="scope.row.ranking"  @change="update(scope.row)" ></el-input-number>
                    </template>
                </el-table-column>
                <el-table-column  label="操作"  align="center">
                    <template slot-scope="scope" >
                        <el-button plain size="mini" type="danger" @click="remove(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
        <el-dialog :title="dialogTitle" center :visible.sync="dialogVisible" width="1234px" :before-close="cancel">
            <el-table border
                      ref="multipleTable"
                      :data="appLinks"
                      tooltip-effect="dark"
                      style="width: 100%"
                      @selection-change="handleSelectionChange"
                      stripe
                      :row-key="getRowKeys"
                      :row-class-name="gameRowTableClass">
                <el-table-column
                        type="selection"
                        :reserve-selection="true"
                        width="55">
                </el-table-column>
                <el-table-column label="应用ID" prop="id" align="center"></el-table-column>
                <el-table-column label="应用名称" prop="name" align="center"></el-table-column>
                <el-table-column label="详细" prop="detail" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column label="跳转链接" prop="widgetScheme" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column  label="应用图片"  align="center">
                    <template slot-scope="scope">
                        <template>
                            <img :src="VUE_APP_CDN_URL+scope.row.image" width="60px" height="60px" />
                        </template>
                    </template>
                </el-table-column>
                <el-table-column  label="线性图标"  align="center">
                    <template slot-scope="scope">
                        <template>
                            <img :src="VUE_APP_CDN_URL+scope.row.imageLine" width="60px" height="60px" />
                        </template>
                    </template>
                </el-table-column>
            </el-table>

            <h1 style="text-align: center;">
                <el-button type="primary" @click="confirm">确 定</el-button>
                <el-button type="info" @click="cancel">取 消</el-button>
            </h1>

        </el-dialog>

    </div>
</template>

<script>
    import {
        blockAppLinks,
        saveBlockAppLink,
        appLinks,
        updateBlockAppLink,
        deleteBlockAppLink
    }from "@/http/iosApi";
    export default {
        name: "SelectAppLink",
        data(){
            return{
                secondBlock: {},
                appLinks:[],
                selectForm:{},
                selectList:[],
                VUE_APP_CDN_URL:'',
                dialogTitle:'',
                multipleSelection: [],
                dialogVisible : false,
                appSelectors :{},
            }
        },
        methods:{
            goBack() {
                if(this.secondBlock.type ===1){
                    this.$router.push({path: '/secondBlockRule'});
                }else if (this.secondBlock.type ===2){
                    this.$router.push({path: '/secondCategoryManage' });
                }else if (this.secondBlock.type ===3){
                    this.$router.push({path: '/defaultManage' });
                }else if (this.secondBlock.type ===4){
                    this.$router.push({path: '/defaultManage' });
                }

            },
            getRowKeys(row){
                return row.id
            },
            gameRowTableClass({row,rowIndex}){
                row.index=rowIndex
            },
            queryList(){
                blockAppLinks(this.secondBlock.id).then(resp => {
                    this.selectList = resp.data.info;
                })
            },
            appLinkList(){
                appLinks().then(resp => {
                    this.appLinks = resp.data.info;
                    this.selectList.forEach(item => {
                        this.$refs.multipleTable && this.$refs.multipleTable.toggleRowSelection(item.appLink, true)
                    })
                })
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            showDetails(title) {
                this.dialogTitle = title;
                this.dialogVisible = true;
                this.appLinkList();

            },
            clear(){
                this.$refs.multipleTable.clearSelection();
            },
            remove(id){
                this.$confirm('此操作将永久删除该配置, 是否继续?', '提示', {
                    cancelButtonClass: 'btn-custom-cancel',
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteBlockAppLink(id).then(resp=> {
                        if (resp.data.status === 0) {
                            this.queryList()
                        }
                    });
                }).catch(() => {
                })
            },

            confirm(){
                let appIds =[];
                this.appSelectors.blockId = this.secondBlock.id;
                this.multipleSelection.forEach(item =>{
                    appIds.push(item.id)
                });
                this.appSelectors.appIds = appIds;
                let _message = '';
                if(this.appSelectors.appIds === '' || this.appSelectors.appIds.length<1){
                    _message = '请勾选应用名称'
                }
                if(_message){
                    this.$message({
                        message: _message,
                        type: 'error'
                    });
                    return;
                }
                saveBlockAppLink(this.appSelectors).then(resp=> {
                    if (resp.data.status===0){
                        this.dialogVisible=false;
                        this.queryList();
                    }
                });
            },
            cancel(){
                this.clear();
                this.dialogVisible=false;
            },
            update(row){
                this.selectForm = {
                    "id" : row.id,
                    "ranking" :row.ranking,
                    "appLinkId" : row.appLinkId,
                    "blockId" : row.blockId
                };

                updateBlockAppLink(this.selectForm).then(resp=> {
                    if (resp.data.status===0){
                        this.queryList();
                    }
                })
            }
        },
        created() {
            this.secondBlock = this.$store.state.secondBlock;
            this.queryList();
        },
        mounted() {
            this.VUE_APP_CDN_URL= process.env.VUE_APP_CDN_URL;
        }
    }
</script>

<style scoped>

</style>